import { useFetchCategoryStatusCompanies } from "@lhd/hooks";
import CommonSelector from "@lhd/components/CommonSelector";
import { useMemo } from "react";
import { ICommonFieldProps } from "../../../../interfaces";

const WorkerTypeOptionsEditCell = (props: ICommonFieldProps) => {
  const { defaultValue, onChange, colDef } = props;
  const columnOptions = colDef.options ?? [];
  const { data: categoryStatusCompaniesData } = useFetchCategoryStatusCompanies(
    { screen: "workers", record_type: "category" },
    columnOptions.length === 0,
  );

  const workerTypeOptions = useMemo(() => {
    if (columnOptions.length > 0) return columnOptions;

    const workerTypes =
      categoryStatusCompaniesData?.data?.reduce<Record<string, string>>(
        (previousValue, currentValue) => ({
          ...previousValue,
          [currentValue?.name]: currentValue?.name,
        }),
        {},
      ) ?? {};

    return Object.keys(workerTypes).map((workerType) => ({
      value: workerType,
      label: workerTypes[workerType],
    }));
  }, [categoryStatusCompaniesData?.data, columnOptions]);

  return (
    <CommonSelector
      defaultValue={defaultValue ?? undefined}
      options={workerTypeOptions}
      height="calc(100% - var(--cell-vertical-spacing))"
      showSearch
      optionFilterProp="label"
      onChange={(value) => onChange?.(value ?? "")}
    />
  );
};

export default WorkerTypeOptionsEditCell;
